<template>
  <div class="timeline-content">
    <div class="help-center-wrapper">
      <helpCenterEntry></helpCenterEntry>
    </div>
    <div class="timeline-content-start">
      <div class="timeline-play-content">
        <div class="play-btn" @click.stop="preview" @mousedown.stop>
          <i :class="isPlay ? 'pause': 'play'"></i>
        </div>
        <div class="play-time-show">
          <div class="now-time">{{nowTime | formatTime}}</div>
          <span>/</span>
          <div class="total-time">{{totalTime | formatTime}}</div>
        </div>
      </div>
      <div class="show-hide-btn">
        <el-tooltip
          v-for="l,i in lines"
          :key="l.type+i"
          :content="l.text"
          effect="dark"
          placement="top"
        >
          <div
            :class="{'hide-status': !l.show}"
            @click="showHideLine(l)"
          >
            <i :class="['iconfont', l.icon]"></i>
          </div>
        </el-tooltip>
        <div v-show="false" class="hide-status">
          <i class="iconfont iconyinxiao"></i>
        </div>
      </div>
    </div>
    <div class="timeline-content-box">
      <div class="timeline-box-header">
        <div class="scroll-overflow">
          <div
            v-for="l,i in lines"
            :key="l.type+i"
            v-show="l.show"
          >
            <i :class="['iconfont', l.icon]"></i>
            <span>{{l.text}}</span>
          </div>
        </div>
      </div>
      <div class="timeline-box-body" ref="timelineBody" @scroll="scrollEvent">
        <div class="slider-timeline" :style="{left: nowTime*secondWidth + 10 + 'px'}" v-drag>
          <div class="slider-box" data-action="handle"></div>
          <!-- 45 - 11  +  102 / 2 + (24 * n +  10 * (n -1)) / 2 + 10-->
          <div class="slider-line" :style="{height: 95+(24*showLineNumber+10*(showLineNumber-1))/2 + 'px'}">
            <div data-action="handle"></div>
          </div>
        </div>
        <div class="axis-timeline" :style="axisStyle">
          <div class="axis-first"></div>
          <div class="axis-second" v-for="n in totalTimeInt">
            <div class="second-time" :class="{'time-over-color': n-1>totalTime}">{{n-1 + 's'}}</div>
            <div class="second-line">
              <div v-for="i in 9" :class="{'middle-line': i === 5}"></div>
            </div>
          </div>
          <div class="axis-last" :class="{'time-over-color': totalTimeInt>totalTime}">
            <span>{{totalTimeInt + 's'}}</span>
          </div>
        </div>
        <div class="axis-timeline-mask" :style="axisStyle" @click="rulerClick($event)"></div>
        <div
          class="axis-timeover-mask"
          :style="{
            width: (totalTimeInt - totalTime) * secondWidth + 2 + 'px',
            left: totalTime*secondWidth + 17 + 'px'
          }"
        ></div>
        <div class="contain-box" :style="axisStyle">
          <div class="hidden-scrollbar" :style="{width: scrollWidth+40+'px'}">
            <components
              v-for="l,i in lines"
              :is="l.type"
              :key="l.type+i"
              v-show="l.show"
              :totalTime="totalTime"
              :totalWidth="totalWidth"
              :secondWidth="secondWidth"
              :scenesTime="scenesTime"
              :nowTime="nowTime"
              :isPlay="isPlay"
              :scrollLeft="scrollLeft"
              :limitRight="limitRight"
              @changeNowTime="changeNowTime"
              @changeScrollLeft="changeScrollLeft"
              @initScencePlay="initScencePlay"
            ></components>
          </div>
        </div>
        <div class="scenes-split-box">
          <div
            v-for="(s,j) in timeNode"
            :key="j"
            :style="{left: `${s*secondWidth}px`}"
          >
            <span @click="changeTimeToScenes(s)">{{`场景${j+1}`}}</span>
            <div></div>
          </div>
        </div>
      </div>
      <div class="timeline-box-footer">
        <div class="scroll-overflow">
          <div
            v-for="l,i in lines"
            :key="l.type+i"
            v-show="l.show"
          >
            <volume :show="l.volume" :volumeType="l.type"></volume>
          </div>
        </div>
      </div>
      <div class="scroll-left-line" v-drag v-show="scrollWidth > visibleWidth">
        <div class="scroll-left-handle" :style="handleXStyle" data-action="scrollX"></div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>
<script>
import { mapGetters, mapMutations} from "vuex";
import subtitle from './subtitle';
import dubbing from './dubbing';
import music from './music';
import volume from './volume';
import helpCenterEntry from '../resourcesArea/helpCenter/helpCenterEntry.vue'

export default {
  name: "TimelineContent",
  components: {
    subtitle: subtitle,
    dubbing: dubbing,
    music: music,
    volume:volume,
    helpCenterEntry
  },
  data() {
    return {
      isPlay: false,
      oldFrame: 0,
      secondWidth: 143.5, // 每一秒的宽度
      nowTime: 0,
      totalTimeInt: 0, // 应该显示的总时间
      totalWidth: 0, // 字幕轴的总长度
      scrollWidth: 0, // 滚动元素里面的总高度
      visibleWidth: 0, // 滚动元素可见的宽度
      scrollLeft: 0, // 滚动值
      lines: [
        {type: 'subtitle', show: true, text: '字幕', icon: 'iconzimu', volume: false},
        {type: 'dubbing', show: true, text: '配音', icon: 'iconpeiyin', volume: true},
        {type: 'music', show: true, text: '配乐', icon: 'iconpeile', volume: true}
      ],
      showLineNumber: 3,
      scenesTime: [], // 场景页时间分割点
      timeNode: [0], // 每个scenes的时间节点数组
      playFrame: null,
      limitTimeMove: false, // 是否处于在拖动时间光标时发生的滚动循环事件
      limitTimeFrame: null, // 接收时间光标滚动事件的对象，cancelAnimationFrame
      limitLeft: 0, // 滚动元素的左边位置
      limitRight: 0, // 滚动元素的右边位置
      handleXWidth: 0, // 自定义滚动条的宽度
      handleXLeft: 0, // 自定义滚动条的定位
      mpos: {
        x: 0,
        y: 0,
        nowTime: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      editor: "TOOL",
      selectScene: "SelectScenes_Msg",
      totalTime: "addSoundtrack/getTotalTime",
      getMusicArr: "addSoundtrack/getMusicArr",
    }),
    axisStyle() {
      // 尺子的宽度（等）
      const style = {};
      style.width = this.scrollWidth + "px";
      return style;
    },
    handleXStyle() {
      // 滚动条样式
      const style = {};
      style.width = this.handleXWidth + "px";
      style.left = this.handleXLeft + "px";
      return style;
    }
  },
  watch: {
    nowTime() {
      let data = this.calcFrame();
      if(!data) return;
      if(!this.isPlay) {
        this.editor.player.maskEle.children().hide();
      } else {
        if (data.frame - this.oldFrame < 0) {
          this.$bus.emit("switch_scenes_play", {
            time: this.nowTime * 1000,
            id: data.id
          });
        }
        this.oldFrame = data.frame;
      }

      this.editor.eve.emit("playByFrame", data.frame, data.id);
      this.editor.eve.emit("play_" + data.id, data.frame);
      this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.nowTime * 60)});
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.initStyle(true);
    this.$bus.on("subtitle_keycode_space", () => {
      this.preview();
    })
    window.addEventListener("mousedown", this.stopPlay, false);
    window.addEventListener("resize", this.initStyle, false);
  },
  beforeDestroy() {
    window.removeEventListener("mousedown", this.stopPlay);
    window.removeEventListener("resize", this.initStyle);
    this.$bus.off("subtitle_keycode_space")
  },
  methods: {
    ...mapMutations({
      setTotalTime: "addSoundtrack/setTotalTime"
    }),
    initData() {
      this.getTimeNode();
      this.totalTimeInt = Math.ceil(this.totalTime);
    },
    initStyle(init = false) {
      let tt = Math.ceil(this.totalTime);
      let vw = document.body.clientWidth - 250 - 124 - 54 - 46;
      if(vw < tt * this.secondWidth) {
        this.totalTimeInt = tt;
      } else {
        this.totalTimeInt = Math.floor(vw / this.secondWidth);
      }

      // getBoundingClientRect 会受到window.scrollX的影响，故使用直接计算
      this.totalWidth =  this.secondWidth * this.totalTimeInt;
      this.limitLeft = 124 + 54;
      this.limitRight = this.limitLeft + vw;
      this.visibleWidth = vw;
      this.scrollWidth = this.totalWidth + 20;
      this.$nextTick(() => {
        // ({left: this.limitLeft, right: this.limitRight, width: this.visibleWidth} = this.$refs.timelineBody.getBoundingClientRect())
        if(!init) {
          this.scrollLeft = this.$refs.timelineBody.scrollLeft;
          this.handleXLeft = (this.scrollLeft * (this.visibleWidth - 20)) / this.scrollWidth;
        } else {
          let left = this.secondWidth * this.nowTime;
          if (left > this.visibleWidth) {
            this.timeToScroll(this.nowTime - 0.1, false)
          }
        }
        this.handleXWidth = (this.visibleWidth * (this.visibleWidth - 20)) / this.scrollWidth;
      });
    },
    getTimeNode() {
      let totalTime = 0;
      this.nowTime = 0;
      // 获取每个scenes组的开始和结束时间，并将scenes初始到第0帧
      if (this.editor && this.editor.sprites) {
        for (let i = 0; i < this.editor.sprites.length; i++) {
          let scene = this.editor.sprites[i];
          if(this.selectScene.id === scene.id) {
            this.nowTime = totalTime;
          }
          // eve('playByFrame', null, 0, scene.id)
          this.editor.eve.emit("playByFrame", 0, scene.id);
          this.editor.eve.emit("play_" + scene.id, 0);
          this.editor.player.scenesDict[scene.id].ele.hide();
          totalTime += scene.duration / 1000;
          this.timeNode[i + 1] = totalTime;
          this.scenesTime.push(totalTime);
        }
        this.setTotalTime(totalTime);
        this.scenesTime.pop();
        this.editor.player.maskEle.children().hide();
        this.editor.cancelPlay();
        // eve('playByFrame', null, 1, this.editor.sprites[0].id)
        this.editor.eve.emit("playByFrame", 0, this.selectScene.id);
        this.editor.eve.emit("play_" + this.selectScene.id, 0);
      }
    },
    showHideLine(l) {
      if(!l.show) {
        l.show = true;
        this.showLineNumber++
        return;
      }
      let num = 0
      this.lines.forEach(line => {
        if(line.show === true) num++
      })
      if (num <= 1) {
        return;
      }
      this.showLineNumber--;
      l.show = false;
    },
    preview() {
      let start = null,
        startNode = 0,
        scrollLeft = 0,
        step = null;

      if (!this.isPlay) {
        if (this.nowTime >= this.totalTime) {
          // 时间在最后的时候从头开始
          this.changeScrollLeft(0);
          this.nowTime = 0;
        }
        startNode = this.nowTime;
        this.initScencePlay()
      }

      this.isPlay = !this.isPlay;

      this.$bus.emit("timeline_play_all", {
        isPlay: this.isPlay,
        time: this.nowTime
      });

      step = timestamp => {
        if (!this.isPlay) {
          window.cancelAnimationFrame(this.playFrame);
          return;
        }
        let progress = 0;
        if (!start) start = timestamp;
        progress = (timestamp - start) / 1000;
        this.nowTime = progress + startNode;

        if (this.nowTime < this.totalTime) {
          // 此处的20为了可以让滚动条滚到最开始和最后（同时让光标距离右极限0.1s）
          scrollLeft = this.nowTime * this.secondWidth - this.visibleWidth + 20;
          if(scrollLeft > this.scrollLeft) {
            this.changeScrollLeft(scrollLeft);
          }
          this.playFrame = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(this.playFrame);
          this.nowTime = this.totalTime;
          this.isPlay = false;
          this.$bus.emit("timeline_play_all", {
            isPlay: this.isPlay,
            time: this.nowTime
          });
        }
      };

      this.playFrame = window.requestAnimationFrame(step);
    },
    stopPlay() {
      // 关闭预览
      this.isPlay && this.preview();
    },
    calcFrame() {
      // 计算播放到哪个scenes的帧数
      if (this.timeNode.length) {
        let data = {};
        for (let i = 0; i < this.timeNode.length - 1; i++) {
          if (
            this.nowTime >= this.timeNode[i] &&
            this.nowTime < this.timeNode[i + 1]
          ) {
            data.frame = Math.ceil((this.nowTime - this.timeNode[i]) * 60);
            data.id = this.editor.sprites[i].id;
            return data;
          }
        }
      }
    },
    initScencePlay() {
      // 将当前播放的scenes后面的scenes初始化第0帧
      let isInit = false,
        nowId = "",
        frame = 0;
      for (let i = 0; i < this.timeNode.length - 1; i++) {
        if (isInit && this.editor.sprites[i]) {
          this.editor.eve.emit("playByFrame", 0, this.editor.sprites[i].id);
          this.editor.player.scenesDict[this.editor.sprites[i].id].ele.hide();
          this.editor.sprites[i].effect.reset();
        }
        if (
          this.nowTime >= this.timeNode[i] &&
          this.nowTime <= this.timeNode[i + 1]
        ) {
          isInit = true;
          nowId = this.editor.sprites[i].id;
          frame = Math.ceil(((this.nowTime - this.timeNode[i])) * 60);
          this.editor.sprites[i].effect.reset();
        }
      }
      this.editor.player.maskEle.children().hide();
      this.editor.eve.emit("playByFrame", frame, nowId);
      this.editor.eve.emit("play_" + nowId, frame);
    },
    handleMouseDown(dx) {
      this.mpos.x = dx;
      this.mpos.nowTime = this.nowTime;
      this.$store.commit("addSoundtrack/setSoundtrackState", {type: 'noSet'});
      this.$store.commit("addSoundtrack/setMusicIndex", -1);
      this.$store.commit("subtitle/setSubIndex", -1);
      this.$store.commit("addSoundtrack/setDubbingIndex", -1);
    },
    handleMouseMove(dx) {
      if(dx >= this.limitRight) {
        // 鼠标超过右极限（滚动事件开始触发）
        this.limitTime(1);
      } else if(dx <= this.limitLeft) {
        this.limitTime(-1);
      } else {
        // 回到正常模式下先关闭滚动的循环事件
        this.cancelLimitTime(dx);
        let dt = (dx - this.mpos.x) / this.secondWidth + this.mpos.nowTime;
        this.changeNowTime(dt)
      }
    },
    handleMouseUp(dx) {
      // 回到正常模式下先关闭滚动的循环事件
      this.cancelLimitTime(dx);
    },
    rulerClick(e) {
      let dt = (e.pageX + this.scrollLeft - 10 - this.limitLeft) / this.secondWidth;
      this.changeNowTime(dt);
      this.$store.commit("addSoundtrack/setSoundtrackState", {type: 'noSet'});
      this.$store.commit("addSoundtrack/setMusicIndex", -1);
      this.$store.commit("subtitle/setSubIndex", -1);
      this.$store.commit("addSoundtrack/setDubbingIndex", -1);
    },
    scrollXMouseDown(dx) {
      this.mpos.x = dx;
      this.mpos.scroll = this.scrollLeft;
      this.mpos.handleXLeft = this.handleXLeft;
    },
    scrollXMouseMove(dx) {
      let ds = this.mpos.handleXLeft - this.mpos.x + dx;
      if (ds < 0) {
        ds = 0;
      } else if (ds > this.visibleWidth - 20 - this.handleXWidth) {
        ds = this.visibleWidth - 20 - this.handleXWidth;
      }
      this.handleXLeft = ds;
      this.$refs.timelineBody.scrollLeft = (ds / (this.visibleWidth - 20)) * this.scrollWidth;
    },
    scrollXMouseUp() {
      this.mpos = {};
    },
    limitTime(dire) {
      if(this.limitTimeMove) return;
      this.limitTimeMove = true;
      let start = null,
        startNode = this.scrollToTime(dire === 1),
        step = null,
        dt = 0;
      step = timestamp => {
        if(!start) start = timestamp;
        dt = (dire * (timestamp - start)) / 200 + startNode;
        if (dt <= 0) {
          this.nowTime = 0;
          this.changeScrollLeft(0);
          window.cancelAnimationFrame(this.limitTimeFrame);
        } else if (dt >= this.totalTime) {
          this.nowTime = this.totalTime;
          this.changeScrollLeft(this.scrollWidth - this.visibleWidth);
          window.cancelAnimationFrame(this.limitTimeFrame);
        } else {
          // 让时间光标在显示区0.1的区域，不至于贴近极限位置
          this.nowTime = dt - dire * 0.1;
          this.timeToScroll(dt, dire === 1);
          this.limitTimeFrame = window.requestAnimationFrame(step);
        }
      };

      this.limitTimeFrame = window.requestAnimationFrame(step);
    },
    cancelLimitTime(disx) {
      // 关闭时间拖块触发的滚动循环
      if (this.limitTimeMove) {
        window.cancelAnimationFrame(this.limitTimeFrame);
        this.limitTimeMove = false;
        if (disx) {
          // 回到正常拖动后的mousedown初始值更改
          this.mpos.x = disx;
          this.mpos.nowTime =
            (disx - this.limitLeft) / this.secondWidth + this.scrollToTime();
        }
      }
    },
    scrollToTime(dire) {
      // 通过滚动位置确定时间
      this.scrollLeft = this.$refs.timelineBody.scrollLeft;
      if (dire) {
        // 右极限时间
        return (this.scrollLeft + this.visibleWidth - 10) / this.secondWidth;
      } else {
        // 左极限
        let dx = (this.scrollLeft - 10) / this.secondWidth;
        return dx < 0 ? 0 : dx;
      }
    },
    timeToScroll(t, dire) {
      // 根据时间计算滚动条的位置
      let sl = 0;
      if (dire) {
        // 右极限
        sl = t * this.secondWidth + 10 - this.visibleWidth;
      } else {
        // 左极限
        sl = t * this.secondWidth + 10;
      }
      this.$refs.timelineBody.scrollLeft = sl;
    },
    scrollEvent(e) {
      // 滚动事件
      this.scrollLeft = e.target.scrollLeft;
      this.handleXLeft = (this.scrollLeft * (this.visibleWidth - 20)) / this.scrollWidth;
    },
    changeNowTime(dt) {
      this.nowTime = dt < 0 ? 0 : dt > this.totalTime ? this.totalTime : dt;
    },
    changeScrollLeft(ds) {
      this.scrollLeft = ds;
      this.$refs.timelineBody.scrollLeft = ds;
    },
    changeTimeToScenes(s) {
      this.nowTime = s;
    }
  },
  directives: {
    drag(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        action = '';

      mousemove = e => {
        e.preventDefault();

        _this[`${action}MouseMove`](e.pageX, e.pageY);
      };

      mouseup = e => {
        e.preventDefault();
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this[`${action}MouseUp`](e.pageX, e.pageY);
      };

      el.onmousedown = e => {
        e.preventDefault();
        e.stopPropagation();
        action = e.target.dataset.action;
        if(!action) return;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this[`${action}MouseDown`](e.pageX, e.pageY);
      };

      el.oncontextmenu = () => {
        return false;
      };
    }
  },
  filters: {
    formatTime(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      let min = ~~(duration / 60);
      min = min.toString().padStart(2, '0');
      let sec = Math.floor(duration % 60);
      sec = sec.toString().padStart(2, '0');
      return min + ":" + sec;
    }
  },
}
</script>
<style lang="scss" scoped>
.timeline-content {
  position: absolute;
  display: flex;
  left: 0;
  bottom: 0;
  width: calc(100% - 250px);
  height: 190px;
  background-color: #fff;
  .help-center-wrapper {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 72px;
    height: 72px;
  }
}

.timeline-content-start {
  width: 124px;
  height: 100%;
}

.timeline-play-content {
  width: 100%;
  height: 75%;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.show-hide-btn {
  width: 100%;
  height: 12%;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  div {
    width: 24px;
    height: 24px;
    background-color: #D7DAF2;
    margin-right: 1px;
    cursor: pointer;
    line-height: 24px;

    > i.iconfont {
      font-size: 12px;
    }
  }

  .hide-status {
    background-color: #EDEDF2;
  }
}

.play-btn {
  position: relative;
  margin-bottom: 10px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  outline: none;

  i {
    display: block;
    width: 36px;
    height: 36px;
  }
  i.play {
    background: url("../../../static/svg/play.svg") no-repeat center;
    &:hover,
    &:active {
      background: url("../../../static/svg/play-active.svg") no-repeat center;
    }
  }

  i.pause {
    background: url("../../../static/svg/pause.svg") no-repeat center;
    &:hover,
    &:active {
      background: url("../../../static/svg/pause-active.svg") no-repeat center;
    }
  }
}

.play-time-show {
  display: flex;
  color: #474261;
  font-size: 12px;

  span {
    margin: 0 2px;
  }
}

.timeline-content-box {
  position: relative;
  display: flex;
  align-items: flex-start;
  width: calc(100% - 124px);
  height: 100%;
}

.timeline-box-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 54px;
  height: 102px;
  margin-top: 69px;
  overflow: hidden;

  .scroll-overflow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform-origin: 0 0;
    transform: translate(0px, 0px);

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 24px;
      margin: 5px 0;
      color: #474261;

      > i.iconfont {
        margin-right: 2px;
        font-size: 12px;
      }
    }
  }
}

.timeline-box-body {
  position: relative;
  top: 0;
  left: 0;
  width: calc(100% - 100px);
  height: calc(100% + 40px);
  overflow-x: scroll;
  overflow-y: hidden;

  .slider-timeline {
    position: absolute;
    top: 25px;
    z-index: 20;

    .slider-box{
      position: absolute;
      left: -6px;
      width: 13px;
      height: 16px;
      background-color: #5778FB;
      clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
      cursor: -webkit-grab;
      cursor: grab;
      touch-action: pan-x;

      // &:before {
      //   content: "";
      //   display: block;
      //   border: 5px solid #5778FB;
      //   margin-top: 11px;
      //   border-bottom-color: transparent;
      //   border-right-color: transparent;
      //   border-left-color: transparent;
      // }
    }

    .slider-line {
      position: absolute;
      top: 10px;
      width: 1px;
      background-color: #5778FB;

      div {
        position: relative;
        top: 0;
        left: -2px;
        width: 5px;
        height: 100%;
        cursor: -webkit-grab;
        cursor: grab;
        touch-action: pan-x;
      }
    }
  }

  .axis-timeline {
    position: relative;
    left: 0;
    top: 25px;
    display: flex;
    justify-content: flex-start;
    height: 10px;
    font-size: 12px;
    z-index: 10;
    color: #8f8ba9;
  }

  .axis-second {
    position: relative;
    width: 143.5px;
    height: 8px;
    border-left: 1px solid #babdd6;

    .second-time {
      position: relative;
      left: -50%;
      top: 200%;
    }
    .second-line {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      div {
        width: 10%;
        height: 4px;
        border-right: 1px solid #babdd6;
      }
      .middle-line {
        height: 6px;
      }
    }
  }
  .axis-first,
  .axis-last {
    position: relative;
    top: 1px;
    left: 0;
    width: 10px;
    height: 8px;
    background: #fff;
  }
  .axis-last {
    border-left: 1px solid #babdd6;

    span {
      position: absolute;
      top: 200%;
      left: -200%;
    }
  }

  .axis-timeline-mask {
    position: absolute;
    left: 0;
    top: 25px;
    z-index: 10;
    height: 48px;
    cursor: pointer;
  }
  .axis-timeover-mask {
    position: absolute;
    left: 0;
    top: 25px;
    z-index: 15;
    height: 35px;
    opacity: 0.6;
    background-color: #fff;
  };

  .contain-box {
    position: relative;
    display: flex;
    height: 102px;
    top: 60px;
    overflow: hidden;
    z-index: 10;

    .hidden-scrollbar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow-x: hidden;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .scenes-split-box {
    position: absolute;
    top: 0;
    left: 10px;
    color: #474261;
    height: 100%;
    z-index: 1;

    > div {
      position: absolute;
      top: 0;
      height: 100%;

      span {
        position: absolute;
        width: 50px;
        text-align: center;
        left: -25px;
        height: 24px;
        line-height: 24px;
        cursor: pointer
      }

      div {
        position: absolute;
        top: 25px;
        width: 1px;
        background-color: #EBECF8;
        height: calc(100% - 25px);
      }
    }
    > div:last-child {
      display: none;
    }
    > div:first-child {
      span {
        left: -15px !important;
      }
    }
  }
}

.timeline-box-footer {
  position: relative;
  display: flex;
  align-items: center;
  width: 46px;
  height: 102px;
  padding-left: 3px;
  top: 69px;
  z-index: 10;

  .scroll-overflow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform-origin: 0 0;
    transform: translate(0px, 0px);


    > div {
      position: relative;
      left: 0;
      top: 0;
      height: 24px;
      width: 24px;
      margin: 5px 0;
    }
  }
}

.scroll-left-line {
  position: absolute;
  bottom: 5px;
  left: 64px;
  width: calc(100% - 124px);
  height: 1px;
  z-index: 10;
  // background-color: #d4d6e7;
}
.scroll-left-handle {
  position: relative;
  top: -3px;
  left: 0;
  width: 100px;
  height: 7px;
  border-radius: 3.5px;
  background-color: #bdbfcf;
  cursor: pointer;
}
.line {
  position: absolute;
  top: 25px;
  width: 100%;
  height: 1px;
  background: rgb(240, 240, 248);
}
</style>



// WEBPACK FOOTER //
// src/components/timelineContent/timelineContent.vue